// extracted by mini-css-extract-plugin
export default {"page__body":"ReportsHome_page__body__qgSN+","page__content":"ReportsHome_page__content__85Y2u","MainUser_ReportsMainBox":"ReportsHome_MainUser_ReportsMainBox__9wdx8"};